import Flickity from "flickity";
import { dialog } from "@rynpsc/dialog";
import { clamp } from "../utils/clamp";
import { createNextArrow, createPrevArrow } from "../base/carousel";

export function init() {}

export function create(element) {
	if (!element) {
		return;
	}

	const body = element.querySelector(".js-lightbox-body");
	const images = Array.from(element.querySelectorAll("img"));

	const openers = Array.from(document.querySelectorAll(".js-lightbox-open"));
	const closers = Array.from(document.querySelectorAll(".js-lightbox-close"));

	const dialogInstance = dialog(element.id);
	dialogInstance.create();

	const observer = new IntersectionObserver(loadImage, { root: element });

	const items = element.querySelector(".js-lightbox-items");

	let carousel = new Flickity(items, {
		lazyLoad: true,
		pageDots: false,
		setGallerySize: false,
	});

	const nextButton = element.querySelector(".flickity-prev-next-button.next");
	const prevButton = element.querySelector(
		".flickity-prev-next-button.previous",
	);

	nextButton.innerHTML = createNextArrow();
	prevButton.innerHTML = createPrevArrow();

	openers.forEach((elem) =>
		elem.addEventListener("click", () => dialogInstance.open()),
	);
	closers.forEach((elem) =>
		elem.addEventListener("click", () => dialogInstance.close()),
	);

	carousel.on("change", () => {
		updateCounter();
	});

	update();

	window.addEventListener("resize", update);

	function update() {
		updateHeight();
		updateCounter();
		carousel.reposition();
	}

	function updateHeight() {
		let widths = [];
		let heights = [];

		// Calculate the optimal dimensions to fit image to space.
		images.forEach((img) => {
			const size = calculateSize(
				img.getAttribute("width"),
				img.getAttribute("height"),
				clamp(body.clientWidth, 0, 890),
				body.clientHeight,
			);

			widths.push(size.width);
			heights.push(size.height);
		});

		let min = Math.min(...widths, ...heights);

		// Calculate dimensions so images have equal widths.
		images.forEach((image) => {
			let sourceWidth = image.getAttribute("width");
			let sourceHeight = image.getAttribute("height");
			let r = sourceHeight / sourceWidth;

			let h = min;
			let w = h / r;

			image.style.width = `${w}px`;
			image.style.height = `${h}px`;
		});

		element.querySelector(".js-lightbox-items").style.height = `${min}px`;

		function calculateSize(srcWidth, srcHeight, maxWidth, maxHeight) {
			const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);

			return { width: srcWidth * ratio, height: srcHeight * ratio };
		}
	}

	function updateCounter() {
		let counter = element.querySelector(".js-lightbox-counter");
		counter.textContent = `${carousel.selectedIndex + 1} of ${carousel.cells.length}`;
	}

	function loadImage(entries) {
		entries
			.filter((entry) => entry.isIntersecting)
			.forEach((entry) => {
				let { target } = entry;

				let src = target.getAttribute("data-lightbox-src");
				let srcset = target.getAttribute("data-lightbox-srcset");

				if (srcset) {
					target.srcset = srcset;
				}

				if (src) {
					target.src = src;
				}
			});
	}

	function open(index = 0) {
		dialogInstance.open();
		carousel.select(index, false, true);
		update();
	}

	dialogInstance.on("open", () => {
		element.scrollTop = 0;

		let scrollbarWidth =
			window.innerWidth - document.documentElement.clientWidth;
		document.body.style.overflow = "hidden";
		document.body.style.paddingRight = `${scrollbarWidth}px`;

		images.forEach((img) => observer.observe(img));
	});

	dialogInstance.on("close", () => {
		images.forEach((img) => observer.unobserve(img));
		dialogInstance.element.addEventListener("transitionend", onTransitionEnd);
	});

	function onTransitionEnd(event) {
		if (event.propertyName !== "opacity") {
			return;
		}

		document.body.style = "";
		document.body.style.paddingRight = "";

		dialogInstance.element.removeEventListener(
			"transitionend",
			onTransitionEnd,
		);
	}

	return { open };
}
